
      const BASE = import.meta.env.BASE_URL
      const bgUrl = `${BASE}loading/bg_combo.webp`
      const frameUrl = `${BASE}loading/pic_combo_01.png`
      const lottieUrl = `${BASE}loading/loading_cmb.json`

      const overlay = document.getElementById('loading-overlay')
      const container = document.getElementById('animation_cmb_container')
      const lottie = document.getElementById('animation_cmb')
      const loader = document.getElementById('custom-loader')
      const fill = loader.querySelector('.fill')

      container.style.backgroundImage = `url(${bgUrl})`

      // 進度條外框：先預載貼圖，解碼完成才套用 border-image 並顯示，避免露出白色實線框；
      // 載入失敗則降級為透明框（金色填充條仍能顯示進度）。
      const revealLoader = () => {
        loader.style.visibility = 'visible'
      }
      const frameImg = new Image()
      frameImg.onload = () => {
        loader.style.borderImageSource = `url(${frameUrl})`
        revealLoader()
      }
      frameImg.onerror = revealLoader
      frameImg.src = frameUrl

      // 中央 Lottie：dotlottie-wc v0.9 建立時無 src 便不自動載入，事後設 src 也不保證觸發；
      // 故改用實例 load() API 並重試到 WASM core 就緒。失敗則優雅降級（僅缺中央動畫）。
      let lottieLoaded = false
      const initLottie = () => {
        const inst = lottie.dotLottie
        if (!inst || lottieLoaded) {
          return
        }
        if (inst.isLoaded) {
          lottieLoaded = true
          return
        }
        try {
          inst.addEventListener('load', () => {
            lottieLoaded = true
          })
          inst.load({ src: lottieUrl, autoplay: true, loop: true })
        } catch (e) {
          /* core 未就緒，下次重試 */
        }
      }
      customElements.whenDefined('dotlottie-wc').then(() => {
        let tries = 0
        const iv = setInterval(() => {
          if (lottieLoaded || (lottie.dotLottie && lottie.dotLottie.isLoaded)) {
            clearInterval(iv)
            return
          }
          initLottie()
          if (++tries > 40) {
            clearInterval(iv)
          }
        }, 200)
      })

      // 動態切換解析度／視窗尺寸自適配：
      // - 疊層其餘元素（背景 cover、進度條、icon 的 vw/vh）由 CSS 於尺寸變更時自動重算；
      // - 中央 Lottie 的 canvas 在 shadow DOM 內，顯示尺寸雖隨 host 縮放，但 backing 解析度
      //   不會自動更新（放大時會被拉伸模糊），須呼叫 inst.resize() 重設。改用 ResizeObserver
      //   直接觀察 host 實際尺寸變化（比 window resize 事件更可靠，含 devtools/全螢幕/容器變動），
      //   並以 rAF 合併連續變更，等版面穩定後才重設解析度。
      let resizeRaf = 0
      const syncLottieSize = () => {
        cancelAnimationFrame(resizeRaf)
        resizeRaf = requestAnimationFrame(() => {
          const inst = lottie.dotLottie
          if (inst && typeof inst.resize === 'function') {
            inst.resize()
          }
        })
      }
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(syncLottieSize).observe(lottie)
      }
      window.addEventListener('resize', syncLottieSize)
      window.addEventListener('orientationchange', syncLottieSize)

      // 與遊戲啟動流程的共享狀態（main.ts 經 src/boot/loadingProgress.ts 寫入）。
      const shared = (window.__GAME_LOADING = window.__GAME_LOADING || {
        progress: 0,
        ready: false,
      })

      // 進度條設計（避免「倒退」與「卡住」）：
      // - 時間估計曲線（漸近至 BAR_CAP）讓進度即使沒有新進度也持續緩慢前進、不像當機；
      // - 取真實進度與時間估計較大者並單調遞增、封頂 BAR_CAP；就緒後快速補滿到 100% 再淡出。
      const BAR_CAP = 0.92 // 真正就緒前進度條上限
      const TAU_MS = 5000 // 時間估計曲線時間常數
      const HARD_TIMEOUT_MS = 60000 // 逾時強制淡出（極端卡死保險）

      let displayed = 0 // 顯示值 0..1（永遠只向前）
      let removed = false
      const pageStart = performance.now()
      let lastAnim = pageStart

      const setBar = (v) => {
        fill.style.width = (Math.max(0, Math.min(1, v)) * 100).toFixed(1) + '%'
      }

      const fadeOut = () => {
        if (removed) {
          return
        }
        removed = true
        overlay.classList.add('hide')
        setTimeout(() => overlay.remove(), 650)
      }

      const animate = (now) => {
        const dt = Math.min(0.1, (now - lastAnim) / 1000)
        lastAnim = now
        const elapsed = now - pageStart
        const ready = shared.ready || elapsed > HARD_TIMEOUT_MS
        if (ready) {
          displayed = Math.min(displayed + dt * 2.5, 1) // 就緒後快速補滿
          setBar(displayed)
          if (displayed >= 1) {
            fadeOut()
            return
          }
        } else {
          const timeEst = BAR_CAP * (1 - Math.exp(-elapsed / TAU_MS))
          const want = Math.min(BAR_CAP, Math.max(shared.progress, timeEst, displayed))
          if (displayed < want) {
            const speed = Math.max(0.25, (want - displayed) * 3) // 每秒前進量
            displayed = Math.min(displayed + speed * dt, want)
          }
          setBar(displayed)
        }
        requestAnimationFrame(animate)
      }
      requestAnimationFrame(animate)
    